
import { fetchAllAttachments } from "./Thunk/employeeThunk";
import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  attachments: [],
  attachmentsHistory: [],
  loading: false,
  error: null,
};

const attachmentsSlice = createSlice({
  name: "attachment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAttachments.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchAllAttachments.fulfilled, (state, action) => {
        state.attachments = action.payload.attachments;
        state.attachmentsHistory = action.payload.attachmentsHistory;
      })
      .addCase(fetchAllAttachments.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default attachmentsSlice.reducer;
